import { alpha, Box, styled } from '@mui/material';
import { DELTA_CARD_SIZES } from '../constants';
import { StatisticSize, Trend } from '../types';

export const DeltaCardLabelWrapper = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'size',
})<{ size?: StatisticSize }>(({ theme, size = 'md' }) => {
  const sizeConfig = DELTA_CARD_SIZES[size] ?? DELTA_CARD_SIZES.md;
  return {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    fontSize: sizeConfig.labelFontSize,
    color: theme.palette.text.secondary,
    lineHeight: 1.5,
  };
});

export const DeltaCardTagRow = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'size',
})<{ size?: StatisticSize }>(({ theme, size = 'md' }) => {
  const sizeConfig = DELTA_CARD_SIZES[size] ?? DELTA_CARD_SIZES.md;
  return {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(sizeConfig.tagGap),
  };
});

export const DeltaCardDeltaTag = styled(Box, {
  shouldForwardProp: (prop) => !['trend', 'size'].includes(prop as string),
})<{ trend?: Trend; size?: StatisticSize }>(({ theme, trend, size = 'md' }) => {
  const sizeConfig = DELTA_CARD_SIZES[size] ?? DELTA_CARD_SIZES.md;
  const bgColor =
    trend === 'positive'
      ? theme.palette.success.main
      : trend === 'negative'
        ? theme.palette.error.main
        : theme.palette.text.secondary;
  return {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: alpha(bgColor, theme.palette.mode === 'dark' ? 0.3 : 0.1),
    border: '1px solid',
    borderColor: bgColor,
    color: theme.palette.text.primary,
    fontWeight: 500,
    borderRadius: 6,
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
    paddingTop: theme.spacing(0.5),
    paddingBottom: theme.spacing(0.5),
    fontSize: sizeConfig.tagFontSize,
    lineHeight: 1.5,
  };
});
